import React, { useEffect, useState } from 'react';
import { useAdminLanguage } from '../AdminLanguageContext';
import api from '../api';
import './Dashboard.css';

function StatCard({ icon, label, value, sub }) {
  return (
    <div className="stat-card">
      <div className="stat-icon">{icon}</div>
      <div className="stat-body">
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
        {sub && <div className="stat-sub">{sub}</div>}
      </div>
    </div>
  );
}

function MiniChart({ data, color = '#4154f1', emptyText }) {
  if (!data || data.length === 0) return <div className="mini-chart-empty">{emptyText}</div>;
  const max = Math.max(...data.map(d => d.cnt), 1);
  return (
    <div className="mini-chart">
      {data.map((d, i) => (
        <div key={i} className="bar-wrap" title={`${d.day}: ${d.cnt}`}>
          <div className="bar" style={{ height: `${(d.cnt / max) * 100}%`, background: color }} />
          <div className="bar-label">{d.day?.slice(5)}</div>
        </div>
      ))}
    </div>
  );
}

export default function Dashboard() {
  const { copy } = useAdminLanguage();
  const dashboardCopy = copy.dashboard;
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats').then(res => setStats(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, color: '#6b7280' }}>{dashboardCopy.loading}</div>;
  if (!stats) return null;

  return (
    <div>
      <div className="page-title">{dashboardCopy.title}</div>

      {/* 核心指标 */}
      <div className="stats-grid">
        <StatCard icon="👥" label={dashboardCopy.stats.users} value={stats.users} sub={dashboardCopy.sub.newThisWeek(stats.newUsers7d)} />
        <StatCard icon="📋" label={dashboardCopy.stats.tasks} value={stats.tasks} sub={dashboardCopy.sub.openTasks(stats.openTasks)} />
        <StatCard icon="💬" label={dashboardCopy.stats.posts} value={stats.posts} sub={dashboardCopy.sub.newThisWeek(stats.newPosts7d)} />
        <StatCard icon="⭐" label={dashboardCopy.stats.avgRating} value={`${stats.avgRating}/5`} sub={dashboardCopy.sub.reviews(stats.reviews)} />
        <StatCard icon="💰" label={dashboardCopy.stats.bids} value={stats.bids} />
        <StatCard icon="🔁" label={dashboardCopy.stats.replies} value={stats.replies} />
      </div>

      {/* 趋势图表 */}
      <div className="charts-row">
        <div className="card chart-card">
          <div className="chart-title">{dashboardCopy.charts.users14d}</div>
          <MiniChart data={stats.userTrend} color="#4154f1" emptyText={dashboardCopy.empty} />
        </div>
        <div className="card chart-card">
          <div className="chart-title">{dashboardCopy.charts.tasks14d}</div>
          <MiniChart data={stats.taskTrend} color="#10b981" emptyText={dashboardCopy.empty} />
        </div>
      </div>

      {/* 快捷操作 */}
      <div className="card" style={{ marginTop: 20 }}>
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 16 }}>{dashboardCopy.quickActionsTitle}</div>
        <div className="quick-actions">
          {[
            { label: dashboardCopy.quickActions.users, href: '/users', icon: '👥', color: '#4154f1' },
            { label: dashboardCopy.quickActions.tasks, href: '/tasks', icon: '📋', color: '#10b981' },
            { label: dashboardCopy.quickActions.posts, href: '/posts', icon: '💬', color: '#f59e0b' },
            { label: dashboardCopy.quickActions.announcements, href: '/announcements', icon: '📢', color: '#8b5cf6' },
            { label: dashboardCopy.quickActions.categories, href: '/categories', icon: '🗂️', color: '#ef4444' },
          ].map(a => (
            <a key={a.href} href={a.href} className="quick-action-btn" style={{ borderColor: a.color, color: a.color }}>
              <span style={{ fontSize: 20 }}>{a.icon}</span>
              <span>{a.label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
